import LanguageSelector from '@app/components/ui/LanguageSelector/LanguageSelector';
import { GlobalSearchTrigger } from '@app/features/globalSearch/GlobalSearchTrigger';
import IssueReportTrigger from '@app/features/issueReporting/IssueReportTrigger';
import NotificationsWidget from '@app/features/notifications/notificationsWidget/NotificationsWidget';
import PlanningSessionIndicator from '@app/features/planningSession/components/PlanningSessionIndicator';
import { useHeader } from '@context/header';
import useUiContext from '@context/ui/useUiContext';
import { Button } from 'antd';
import React, { memo, type ReactNode } from 'react';
import { Title } from 'react-head';
import { FiSidebar } from 'react-icons/fi';

const isString = (node: ReactNode): node is string => typeof node === 'string';
const isReactElement = (node: ReactNode): node is React.ReactElement => React.isValidElement(node);

const HeaderLayout = memo(() => {
  const { toggleSidebarCollapse } = useUiContext();
  const { title } = useHeader();

  const titleText = isString(title) ? title : isReactElement(title) ? 'LOOM' : 'LOOM';

  return (
    <>
      <Title>{titleText}</Title>

      {/* Header row (auto height, never grows) */}
      <div className="shrink-0 flex justify-between items-center py-2 px-4 border-b border-slate-100">
        <div className="flex min-w-0 gap-4 items-center">
          <div className="xs:hidden block" onClick={() => toggleSidebarCollapse()}>
            <Button className="text-xl bg-white leading-none" type="link" icon={<FiSidebar className="text-lg" />} />
          </div>

          <div className="min-w-0 truncate text-lg text-slate-600">{title}</div>
        </div>

        <div className="flex shrink-0 items-center gap-2">
          <GlobalSearchTrigger />

          <PlanningSessionIndicator />

          <LanguageSelector />

          <IssueReportTrigger />

          {/* No unread-notes indicator here: there is no notes inbox to send a reader
              to, so the badge was a count with nowhere to go. `NotesUnreadBadge` and
              `useUnreadNoteCount` stay in the notes module for when one exists. */}

          <NotificationsWidget />
        </div>
      </div>
    </>
  );
});

HeaderLayout.displayName = 'HeaderLayout';

export default HeaderLayout;
